import { saveWordClient } from "./apiClient";

const saveWordApi = async (data) => {
  return await saveWordClient.post("/api/v1/userSaveWord/saveWord", data);
};

const getDetalisListOfUserWordsApi = async (data, paginate) => {
  return await saveWordClient.post(
    `/api/v1/userSaveWord/getDetalisListOfUserWords?limit=${paginate.perPage || 10}&page=${paginate.page || 1}`,
    data
  );
};

const deleteWordApi = async (dataObject) => {
  return await saveWordClient.delete("/api/v1/userSaveWord/deleteWord", {
    data: dataObject,
  });
};

const deleteWordsByWordApi = async (dataObject) => {
  return await saveWordClient.delete("/api/v1/userSaveWord/deleteWordsByWord", {
    data: dataObject,
  });
};

const getListOfWordGroupsApi = async (data, paginate) => {
  return await saveWordClient.post(
    `/api/v1/userSaveWord/getListOfWordGroups?limit=${paginate.perPage || 50}&page=${paginate.page || 1}`,
    data
  );
};

const getShortListOfWordGroups = async (data) => {
  return await saveWordClient.post("/api/v1/userSaveWord/getShortListOfWordGroups", data);
};

const getListOfUserWordsByGroupApi = async (data, paginate) => {
  return await saveWordClient.post(
    `/api/v1/userSaveWord/getListOfUserWordsByGroup?limit=${paginate.perPage || 50}&page=${paginate.page || 1}`,
    data
  );
};

const editWordApi = async (data) => {
  return await saveWordClient.patch("/api/v1/userSaveWord/editWord", data);
};

const addNewWordGroupApi = async (data) => {
  return await saveWordClient.post("/api/v1/userSaveWord/addNewWordGroup", data);
};

const editWordGroupNameApi = async (data) => {
  return await saveWordClient.patch("/api/v1/userSaveWord/editWordGroupName", data);
};

const removeWordGroup = async (dataObject) => {
  return await saveWordClient.delete("/api/v1/userSaveWord/removeWordGroup", {
    data: dataObject,
  });
};

export {
  saveWordApi,
  getDetalisListOfUserWordsApi,
  deleteWordApi,
  deleteWordsByWordApi,
  getListOfWordGroupsApi,
  getShortListOfWordGroups,
  getListOfUserWordsByGroupApi,
  editWordApi,
  addNewWordGroupApi,
  editWordGroupNameApi,
  removeWordGroup,
};
